// extracted by mini-css-extract-plugin
export default {"whyUsBox":"whyus_whyUsBox__mMVpI"};